import { ToolbarController } from './toolbar.controller';
import { DirectiveBase } from '../../components/angular-directive-base.directive';

export class Toolbar extends DirectiveBase {
  constructor() {
    super();
    this.bindToController = true;
    this.controller = ToolbarController;
    this.controllerAs = 'vm';
    this.restrict = 'E';
    this.scope = {
      name: '@?'
    };
    this.transclude = true;
    this.templateUrl = 'app/angularJS/layout/toolbar/toolbar.html';
  }
}